import {clone, filter, findIndex, head, keys, length, prop, propEq} from 'ramda'
import api from './api'
import Debug from 'debug'
import moment from 'moment-timezone'
const debug = Debug('app:shared:crews')

const crews = ($http, $q, Auth, Users) => {
  'ngInject'

  var crews = []
  const findCrewIndex = id => findIndex(propEq('id', id), crews)
  let selectedCrew

  const getCrews = () => {
    if (crews && length(keys(crews))) {
      debug('pulling crew from cache')
      let def = $q.defer()
      def.resolve(crews)
      return def.promise
    }
    return fetchCrews()
  }

  const selectCrew = (crew) => {
    selectedCrew = crew
    console.log('set crew!', crew)
  }

  const getSelectedCrew = () => selectedCrew

  const fetchCrews = () => {
    return $http({
      method: 'GET',
      url: `${api.getBase()}/company/crew/get`
    })
    .then(prop('data'))
    .then(getCrewSuccess)
  }

  const removeCrewSuccess = (id) => {
    crews = filter(x => x.id === id, crews)
  }

  const removeCrew = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/company/crew/delete`,
      data
    })
    .then(removeCrewSuccess)
  }

  const addUsersToCrew = (users) => {
    if (!selectedCrew) throw new Error('no crew selected')

    return $http({
      method: 'POST',
      url: `${api.getBase()}/company/crew/addUsers`,
      data: {
        crewId: selectedCrew.id,
        users
      }
    })
    .then(prop('data'))
    .then((updatedCrews) => {
      console.log(updatedCrews)
      const crew = clone(head(updatedCrews))
      crews[findCrewIndex(crew.id)] = crew
    })
  }

  const updateCrew = (data) => {
    const massaged = {
      crewId: data.xhr.id,
      name: data.xhr.name,
      users: data.xhr.users
    }

    return $http({
      method: 'POST',
      url: `${api.getBase()}/company/crew/update`,
      data: massaged
    })
    .then(() => {
      const updatedCrew = {
        id: data.xhr.id,
        name: data.xhr.name,
        createdAt: data.createdAt,
        users: data.users
      }
      crews[findCrewIndex(data.xhr.id)] = clone(updatedCrew)
    })
  }

  /**
   * Make http request to create the crew. Add created crew to cached crews array.
   */
  const addCrew = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/company/crew/add`,
      data: data.xhr
    })
    .then(prop('data'))
    .then((x) => {
      const insertedCrew = {
        id: x,
        name: data.xhr.name,
        createdAt: moment().format(),
        users: data.users
      }
      crews.push(insertedCrew)
    })
  }

  const getCrewSuccess = (res) => {
    crews = res
    return crews
  }

  return {
    getCrews,
    removeCrew,
    addCrew,
    addUsersToCrew,
    updateCrew,
    selectCrew,
    getSelectedCrew
  }
}

export default crews
